/*
  Shoebox Drive Survey
  Copyright 2025 New Missions
*/

export const PAGES = [
  {
    index: 0,
    submitLabel: 'Host a Shoebox Drive',
    questions: [
      {
        id: 'firstName',
        label: 'First Name',
        required: true
      },
      {
        id: 'lastName',
        label: 'Last Name',
        required: true
      },
      {
        id: 'email',
        label: 'Email',
        type: 'email',
        required: true
      }
    ]
  },
  {
    index: 1,
    submitLabel: 'Next',
    questions: [
      {
        id: 'orgName',
        label: 'Organization Name',
        required: true
      },
      {
        id: 'addrStreet',
        label: 'Street Address'
      },
      {
        id: 'addrCityStateZip',
        label: 'City, State, ZIP'
      },
      {
        id: 'hostWhen',
        label: 'When do you plan to host your Shoebox Drive?'
      },
      {
        id: 'collectGoal',
        label: 'How many shoeboxes do you hope to collect?',
        helperText: <>
          If your church needs shoeboxes to distribute for your Shoebox Drive, you can purchase them
          {' '}
          {/* eslint-disable-next-line */}
          <a href="https://www.uline.com/Product/Detail/S-3182/Indestructo-and-Literature-Mailers/11-1-8-x-8-3-4-x-4-Kraft-Literature-Mailers?keywords=s-3182" target="_blank">here</a>.
        </>
      }
    ]
  },
  {
    index: 2,
    submitLabel: 'Send',
    questions: [
      {
        id: 'sendBrochureCount',
        label: 'How many brochures do you want us to send you?'
      },
      {
        id: 'sendPosterCount',
        label: 'How many posters do you want?'
      },
      {
        id: 'sendShirtSizes',
        label: 'What two T-shirt sizes do you want?',
        helperText: 'We like to send (2) Shoebox Drive T-shirts for the hosts of this campaign.'
      },
      {
        id: 'sendWhenArrive',
        label: 'When do you want the supplies to arrive?'
      },
      {
        id: 'interestedDropOffLocation',
        label: 'Would you be interested in being a drop-off location?',
        helperText: <>
          Yes / No
          <br />
          Enter Yes to receive shoebox gifts from others in your area (we will follow up with you).
        </>
      },
      {
        id: 'notes',
        label: 'Do you have any additional questions or comments?'
      }
    ]
  }
];

export const SUCCESS_MSG = <>
  Thanks for filling out the Shoebox Drive sign-up form!
  Our collection runs from October 1st through December 31st.
  If you have any additional questions feel welcome to email:
  info@newmissions.org or call 407-240-4058.
</>;

export const ERROR_MSG = <>
  An error occurred while sending the form.
  <br />
  Please reload the page and try again, or contact us at:
  <br />
  info@newmissions.org or 407-240-4058
</>;
